import React, { useState, useEffect, useRef } from "react";
import queryString from "query-string";
import { Form, Progress, Alert, Input, Col } from "reactstrap";
import { CSSTransition } from "react-transition-group";

import { useLocalization } from "../../containers/I18nProvider";
import { WithCaptcha } from '../../containers/captcha';
import logo from './img/logo.png'

const LoginForm = ({ api, location, ...props }) => {
  const nodeRef = useRef(null);
  const { translate, changeDefaultLocale } = useLocalization();
  changeDefaultLocale('pt-BR');
  const [onLogin, setOnLogin] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [error, setError] = useState({
    open: false,
    message: "",
  });
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const parameters = queryString.parse(location.search);
  parameters.idp = 'superimg';

  useEffect(() => {
    setShowForm(true)
  }, []);

  const onSubmit = async (ev) => {
    ev.preventDefault();
    setOnLogin(true)
    setError({
      open: false,
      message: "",
    })

    api.userPassLogin(
      {
        username,
        password,
      },
      parameters
    )
      .then((response) => {
        setOnLogin(false)
        window.location = parameters.redirect_uri + "?" + queryString.stringify(response);
      })
      .catch((error) => {
        const _translate = translate(error.errorCode);

        let message = "Houve um erro. Tente novamente";

        if (_translate) {
          message = _translate;
        } else if (error.details) {
          message = error.details;
        }
        setOnLogin(false)
        setError({ open: true, message: message })
      });
  }

  return (
    <CSSTransition
      in={showForm}
      timeout={300}
      classNames="formshow"
      nodeRef={nodeRef}
      unmountOnExit
    >
      <div className="login-superimagem-container text-align-center" ref={nodeRef}>
        <div className="login-superimagem-header" style={{ marginBottom: '20px' }}>
          <img src={logo} alt="logo" className="logo-superimagem rounded mx-auto d-block" />
        </div>
        <div className="login-superimagem-body">
          <div className="login-superimagem-body-header">
            <h3>TELECINE PLAY - NET ANGRA</h3>
          </div>
          <div className="login-superimagem-body-body">
            <Form onSubmit={event => onSubmit(event)}>
              <Col sm="12" xs="12" md="12">
                <Input
                  className="input-superimagem"
                  disabled={onLogin}
                  required={true}
                  tabIndex={1}
                  type="text"
                  autoCorrect="off"
                  autoCapitalize="none"
                  id="username"
                  placeHolder="Entre com seu ID de assinante"
                  onChange={e => setUsername(e.target.value)}

                />
              </Col>
              <Col sm="12" xs="12" md="12">
                <Input
                  className="input-superimagem"
                  required={true}
                  disabled={onLogin}
                  tabIndex={1}
                  type="password"
                  autoCorrect="off"
                  autoCapitalize="none"
                  id="password"
                  placeHolder="Entre com a sua senha"
                  onChange={e => setPassword(e.target.value)}
                />
              </Col>
              <Col sm="12" xs="12" md="12">
                {!onLogin ?
                  <div>
                    <button
                      block={!parameters.failureRedirect}
                      tabIndex={1}
                      className="enter-superimagem"
                      type="submit"
                      name="submit"
                      disabled={!props.turnstileSuccess}
                    >
                      {translate("ButtonEnter")}
                    </button>
                  </div>
                  :
                  <Progress animated color="danger" value={100} />
                }
              </Col>
              <div className="messages-container">
                <Alert color="danger" id="error-message" isOpen={error.open} toggle={() => setError({ open: false })}>
                  {error.message}
                </Alert>
              </div>
            </Form>
          </div>
        </div>
        <div style={{ textAlign: 'center' }}>
          <p style={{ fontSize: '10px' }}>2007-2017 - SUPERIMAGEM TECNOLOGIA EM ELETRÔNICA LTDA. TODOS OS DIREITOS RESERVADOS.</p>
        </div>
      </div>
    </CSSTransition>
  );
}

export default WithCaptcha(LoginForm, { style: { marginTop: '2rem' } });
